import { BookmarkSimple } from "@phosphor-icons/react";

interface EmptyStateCardProps {
  title: string;
  description: string;
}

export default function EmptyStateCard({
  title,
  description,
}: EmptyStateCardProps) {
  return (
    <div className="flex flex-col md:flex-row items-center md:py-[94px] gap-4 md:gap-0 px-[21px] w-full col-span-2 max-h-[214px]">
      <BookmarkSimple
        weight="fill"
        className="rounded-full px-[14px] py-[10px] text-primary bg-secondary aspect-square mr-[26px] !w-20 !h-20"
        size={72}
      />
      <div>
        <h2 className="mb-4 text-form-title">{title}</h2>
        <p className="text-small-content text-light-grey max-w-[314px]">
          {description}
        </p>
      </div>
    </div>
  );
}
